import { useClassificationReviews } from './use-classification-reviews'

export function useClassificationValidationReview({ documentKey }: { documentKey: string }) {
  const { data: classificationReviews } = useClassificationReviews({ documentKey })
  return classificationReviews.items?.find((review) => !!review.document_category) ?? null
}
